exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.our-sponsors{background-color:#e7ebd2;padding:5px 0\n}\n.our-sponsors ul{list-style:none;text-align:center;margin:1rem\n}\n.our-sponsors ul li{display:inline-block\n}", ""]);

// exports
